import { createSlice } from "@reduxjs/toolkit";

export const ubicacionesSlices = createSlice({
  name: "ubicaciones",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = ubicacionesSlices.actions;

export default ubicacionesSlices.reducer;
